import React, { useCallback, useRef, useState } from "react";
import Popup from 'reactjs-popup';
import { useGlobalModalContext } from "./GlobalModal";
import "cropperjs/dist/cropper.css";
import 'react-image-crop/dist/ReactCrop.css';
import Cropper from "react-cropper";
import AvatarEditor from 'react-avatar-editor'

import { RiArrowGoForwardFill } from 'react-icons/ri';


const ImageCropper = () => {

   // const [cropper, setCropper] = useState<any>();
   // const imgRef = useRef<any>(null);
   // const [rotateIndex, setRotateIndex] = useState<number>(0);
   // const [completedCrop, setCompletedCrop] = useState<any>(null);
   // const [crop, setCrop] = useState<any>({
   //    aspect: 4 / 6,
   //    unit: '%', // default, can be 'px' or '%'
   //    x: 25,
   //    y: 25,
   //    width: 30,
   // });

   // const { hideModal, store } = useGlobalModalContext();
   // const { modalProps } = store || {};
   // const { imgURL, setCropImage, buttonText } = modalProps || {};

   // const overlayStyle = { background: 'rgba(0,0,0,0.9)' };

   // const handleModalToggle = () => {
   //    hideModal();
   // };

   // const onLoad = useCallback((img) => {
   //    imgRef.current = img;

   // }, []);




   // const onSaveCropImage = async () => {
   //    const croppedImg = await getCroppedImg();
   //    setCropImage(croppedImg);
   //    handleModalToggle();
   // };

   // const getCroppedImg = () => {
   //    if (!imgRef.current || !completedCrop) {
   //       return;
   //    }

   //    const image = imgRef.current;
   //    const canvas = document.createElement("canvas");
   //    const scaleX = image.naturalWidth / image.width;
   //    const scaleY = image.naturalHeight / image.height;
   //    const ctx = canvas.getContext("2d");
   //    const pixelRatio = window.devicePixelRatio;
   //    canvas.width = crop.width * pixelRatio * scaleX;
   //    canvas.height = crop.height * pixelRatio * scaleY;

   //    if (ctx) {
   //       ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
   //       ctx.imageSmoothingQuality = "high";

   //       ctx.drawImage(
   //          image,
   //          crop.x * scaleX,
   //          crop.y * scaleY,
   //          crop.width * scaleX,
   //          crop.height * scaleY,
   //          0,
   //          0,
   //          crop.width * scaleX,
   //          crop.height * scaleY
   //       );
   //    }


   //    // As Base64 string
   //    const base64Image = canvas.toDataURL("image/jpeg");
   //    return base64Image;

   //    // As a blob
   //    // return new Promise((resolve, reject) => {
   //    //     canvas.toBlob(
   //    //         (blob: any) => {
   //    //             blob.name = "upload";
   //    //             resolve(blob);
   //    //         },
   //    //         "image/jpeg",
   //    //         1
   //    //     );
   //    // });
   // };

   const rotateState: number[] = [0, 90, 180, -90];
   const imgRef = useRef<any>(null);
   const [completedCrop, setCompletedCrop] = useState<any>(null);
   const [cropper, setCropper] = useState<any>();
   const [rotateIndex, setRotateIndex] = useState<number>(0);

   const { hideModal, store } = useGlobalModalContext();
   const { modalProps } = store || {};
   const { imgURL, setCropImage, buttonText } = modalProps || {};

   const overlayStyle = { background: 'rgba(0,0,0,0.9)' };

   const handleModalToggle = () => {
      hideModal();
   };

   const onSaveCropImage = async () => {
      const croppedImg = getCropData();
      setCropImage(croppedImg);
      handleModalToggle();
   };

   const getCropData = () => {
      if (editor.current !== null) {
         return editor.current.getImage().toDataURL();
      }
      // if (typeof cropper !== "undefined") {
      //    return cropper.getCroppedCanvas().toDataURL();
      // }
   };

   const handleRotate = () => {
      let value = rotateIndex;
      if (value < rotateState.length - 1) value++;
      else value = 0;
      setRotateIndex(value);
      cropper.rotateTo(rotateState[value]);
   };

   const editor = useRef(null as any);

   return (
      <div className="pict_edit_sec wf-section" style={{ maxHeight: '100vh' }}>
         <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", height: "7vh", padding: 5, position: 'absolute', top: '0px', right: '15px' }}>
            <a href="#" className="close" style={{ fontSize: "5vh", color: "white" }} onClick={handleModalToggle}>
               &times;
            </a>
         </div>
         {/* <a href="#" className="close_button w-inline-block">
            <img src="assets/images/ic_top_close.svg" loading="lazy" alt="" />
         </a> */}
         {/* <Cropper
            style={{ display: 'flex', justifyContent: 'center', maxWidth: 1000, maxHeight: 500 }}
            zoomable={false}
            // zoomTo={1}
            initialAspectRatio={4 / 6}
            aspectRatio={4 / 6}
            src={imgURL}
            viewMode={1}
            rotatable={true}
            minCropBoxHeight={10}
            minCropBoxWidth={10}
            background={false}
            responsive={false}
            autoCropArea={1}
            checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
            onInitialized={(instance) => {
               setCropper(instance);
            }}
            guides={true}
         /> */}

         <AvatarEditor
            style={{ marginTop: "40px" }}
            ref={editor}
            image={imgURL}
            width={300}
            height={500}
            border={5}
            color={[211, 211, 211, 0.8]} // RGBA
            scale={1}
            rotate={0}
         />
         <div>
            <span>הזיזו את התמונה למיקום הרצוי</span>
         </div>
         <a href="#" onClick={onSaveCropImage} className="button_full pict_edit w-button">שמור תמונה</a>

      </div>





      // <>

      //    <Popup
      //       className={"imageWrapper"}
      //       contentStyle={{
      //          backgroundColor: "black", width: '100%', height: "100%"

      //          , display: "flex", flexDirection: "column", justifyContent: "space-evenly"
      //       }}
      //       position="center center"
      //       open={true}
      //       onClose={handleModalToggle}
      //       overlayStyle={overlayStyle}
      //       closeOnDocumentClick={true}
      //    >
      //       <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", height: "7vh", padding: 10 }}>
      //          <a href="#" className="close" style={{ fontSize: "5vh", color: "white" }} onClick={handleModalToggle}>
      //             &times;
      //          </a>

      //       </div>
      //       {/* <ReactCrop
      //          keepSelection={true}
      //          onChange={(c) => setCrop(c)}
      //          onImageLoaded={onLoad}
      //          src={imgURL}
      //          crop={crop}
      //          locked={false}
      //          onComplete={(c) => setCompletedCrop(c)}
      //          rotate={rotateState[rotateIndex]}
      //       /> */}


      //       <Cropper
      //          style={{ height: 400, maxWidth: "100%", display: 'flex', justifyContent: 'center' }}
      //          zoomable={false}
      //          // zoomTo={1}
      //          initialAspectRatio={4 / 6}
      //          aspectRatio={4 / 6}
      //          src={imgURL}
      //          viewMode={1}
      //          rotatable={true}
      //          minCropBoxHeight={10}
      //          minCropBoxWidth={10}
      //          background={false}
      //          responsive={false}
      //          autoCropArea={1}
      //          checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
      //          onInitialized={(instance) => {
      //             setCropper(instance);
      //          }}
      //          guides={true}
      //       />


      //       <div className="cropButton" style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: 'center' }}>
      //          {/* <button style={{ backgroundColor: 'transparent', width: '50px' }} onClick={handleRotate}><RiArrowGoForwardFill style={{ fontSize: '2rem', color: 'white' }} /></button> */}
      //          <button onClick={onSaveCropImage} className="button_full w-button">{buttonText}</button>

      //       </div>
      //    </Popup>
      // </>
   )
}

export default ImageCropper;